import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=7536a894&scoped=true"
import script from "./ResetButton.vue?vue&type=script&lang=ts"
export * from "./ResetButton.vue?vue&type=script&lang=ts"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=7536a894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536a894",
  null
  
)

export default component.exports